// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2Eqc5","clinicsSelect":"TableHeading_clinicsSelect__36Mcu"};